import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sekoia = defineConnector({
  identifier: "sekoia",
  name: "Sekoia",
  tagLine: "Security operations platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.sekoia\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Sekoia](https://app.sekoia.io/), go to **Settings → API Keys** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sekoia.io/v1/me",
  },
});
